var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H11C9.897 3 9 3.897 9 5V7H5C3.897 7 3 7.897 3 9V19C3 20.103 3.897 21 5 21H13C14.103 21 15 20.103 15 19V17H19C20.103 17 21 16.103 21 15V5C21 3.897 20.103 3 19 3ZM6 18V12L9 15L6 18ZM10 9C10 8.448 10.448 8 11 8C11.552 8 12 8.448 12 9C12 9.552 11.552 10 11 10C10.448 10 10 9.552 10 9ZM11 12C11 11.448 11.448 11 12 11C12.552 11 13 11.448 13 12C13 12.552 12.552 13 12 13C11.448 13 11 12.552 11 12ZM13 16C12.448 16 12 15.552 12 15C12 14.448 12.448 14 13 14C13.552 14 14 14.448 14 15C14 15.552 13.552 16 13 16ZM18 12L15 9L18 6V12Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIntegration);
export default __webpack_public_path__ + "static/media/ic_integration.f0d90fe8fe5de2afe2e5ed08d5da08f7.svg";
export { ForwardRef as ReactComponent };